<template>
  <table class="vcv-table fixed" v-if="table">
    <thead>
      <tr>
        <th v-for="column, i in columns" :class="{'name' : i === 0}">
          <div :class="{'cell-flex' : i === columns.length - 1}">
            <HeaderCell
              :tooltip="$tr(`analytics.recruiters.columns.${column.title}.helper`)"
              :columnNumber="i"
              :title="$tr('analytics.recruiters.columns.user.title1')"
              :titleRows="[
                $tr(`analytics.recruiters.columns.${column.title}.title1`),
                $tr(`analytics.recruiters.columns.${column.title}.title2`)
              ]"
              @setSortingByColumn="setSortingByColumn"
            />
            <img
              v-if="i === columns.length - 1"
              class="trophy"
              src="/static/images/elements/analytics/trophy.svg"
              alt="Trophy icon"
            >
          </div>
        </th>
      </tr>
    </thead>

    <tbody v-if="loading">
      <tr class="no-bottom-line">
        <td colspan="6">
          <div class="spinner"></div>
        </td>
      </tr>
    </tbody>

    <tbody v-else>
      <RecruiterRow
        v-for="(recruiter, index) in rows"
        :key="index"
        :recruiter="recruiter"
      />
      <tr
        class="show no-bottom-line"
        v-if="isMoreThanMaxRows"
      >
        <td colspan="6">
          <vbutton
            :label="showAll ? 'analytics.recruiters.hide' : 'analytics.recruiters.show'"
            color="white-clickable"
            @click="toggleShowHide" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>

import { mapGetters } from 'vuex'

import HeaderCell from './ListHeaderCell.vue';
import RecruiterRow from './RecruiterRow.vue';

const DEFAULT_MAX_ROWS = 5

export default {
  name: 'analytics-recruiters-list',

  components: {
    RecruiterRow,
    HeaderCell
  },

  data () {
    return {
      showAll: false,
      columns: [
        {title: 'user'},
        {title: 'sentInvitations'},
        {title: 'newCandidates'},
        {title: 'hiredCandidates'},
        {title: 'interviewed'},
        {title: 'averageTime'}
      ]
    }
  },

  props: {
    table: Object,
    filtersParams: Object
  },

  watch: {
    filtersParams (val) {
      this.fetch()
    }
  },

  methods: {
    fetch () {
      return this.$store.dispatch('analytics/recruiters/fetch', this.filtersParams)
    },

    setSortingByColumn (numberColumn) {
      const sorting = this.sorting

      this.$store.commit('analytics/recruiters/updateSorting', {
        numberColumn: numberColumn,
        order: (sorting.numberColumn !== numberColumn || sorting.order === 'desc') ? 'asc' : 'desc'
      })

      this.fetch()
    },

    toggleShowHide () {
      this.showAll = !this.showAll
    }
  },

  computed: {
    isMoreThanMaxRows () {
      return this.table ? this.table.rows.length > DEFAULT_MAX_ROWS : false
    },

    rows () {
      const rows = this.table ? this.table.rows : []

      return this.showAll ? rows : rows.slice(0, DEFAULT_MAX_ROWS)
    },

    ...mapGetters({
      sorting: 'analytics/recruiters/sorting',
      loading: 'analytics/recruiters/loading'
    })
  }

}
</script>

<style lang="scss" scoped>
  .vcv-table {
    margin-bottom: 25px;

    .spinner {
      margin: 50px auto;
      height: 50px;
      width: 50px;
    }


    thead tr th {
      color: #7F7F7F;
      padding: 10px 0;
      height: initial;
      width: calc(20%);
      border-bottom: 1px solid #D3D6DA;
      vertical-align: top;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-size: 14px;
      color: #607183;
      letter-spacing: 0.002em;

      &:not(.avatar):hover { cursor: pointer; }

      &.avatar { width: 53px;}

      &.name { 
        padding-left: 9px;
        min-width: 276px;
      }

      &:nth-child(n+1) { padding-right: 17px; }
    }

    tbody tr {
      border-bottom: 1px solid #D3D6DA;
    }

    .no-bottom-line {
      border-bottom: none;
    }

    .show {
      &:hover {
        background: inherit;
      }

      td {
        text-align: center;
        padding: 23px 0;
        color: #3EAF29;
      }
    }
  }

  .cell-flex {
    display: flex;
    align-items: flex-start;

    img {
      margin-top: 5px;
      margin-left: 8px;
    }
  }
</style>
